import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["msg-item", {'jc-right': _ctx.my}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.my ? 'my' : 'partner'])
    }, [
      _createVNode(_component_el_skeleton, {
        animated: "",
        class: "skelet",
        style: _normalizeStyle(_ctx.my ? '--el-skeleton-color: #158AD2' : '--el-skeleton-color: #F0F3F5')
      }, {
        template: _withCtx(() => [
          _createVNode(_component_el_skeleton_item, { variant: "rect" })
        ]),
        _: 1
      }, 8, ["style"])
    ], 2)
  ], 2))
}